import { Card } from '@hivebrite/design-system/Card';

import DiscussionUserAndDropdown from 'hb-react/frontoffice/apps/Forum/components/DiscussionUserAndDropdown';
import type { ConfigUrls } from 'hb-react/frontoffice/apps/Forum/types';
import type { Discussion } from 'hb-react/frontoffice/components/CardForum/types';

import DiscussionCommentedLabel from './components/DiscussionCommentedLabel';
import DiscussionContentAndCover from './components/DiscussionContentAndCover';
import DiscussionReactions from './components/DiscussionReactions';

interface CardForumProps {
  configUrls: ConfigUrls;
  discussion: Discussion;
}

const CardForum = ({ configUrls, discussion }: CardForumProps) => (
  <Card>
    <DiscussionCommentedLabel discussion={discussion} />
    <DiscussionUserAndDropdown
      configUrls={configUrls}
      discussion={discussion}
    />
    <DiscussionContentAndCover
      discussion={discussion}
      configUrls={configUrls}
    />
    <DiscussionReactions discussion={discussion} configUrls={configUrls} />
  </Card>
);

export default CardForum;
